import classes from './FinancesSection.module.scss';

const FinancesSection = () => {
  return (
    <div className={classes.dashboard}>Pénzügyek</div>
  )
}

export default FinancesSection;